module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.d06af131.webp";